import { RadioButtonGroup } from '@/components/RadioButtonGroup';
import { useStoredDeliveryAddresses } from './useStoredDeliveryAddresses';

interface StoredDeliveryAddressesProps {
  headingId: string;
}

export const StoredDeliveryAddresses = ({
  headingId,
}: StoredDeliveryAddressesProps) => {
  const { fields, handleSelectionChange, newAddressField, selectedAddressId } =
    useStoredDeliveryAddresses();

  return (
    <>
      <RadioButtonGroup
        aria-labelledby={headingId}
        fields={fields}
        onChange={handleSelectionChange}
        hasDiscreteFields={true}
        value={selectedAddressId}
      />
      {newAddressField}
    </>
  );
};
